import script from "./ClockIn.vue?vue&type=script&setup=true&lang=js"
export * from "./ClockIn.vue?vue&type=script&setup=true&lang=js"

import "./ClockIn.vue?vue&type=style&index=0&id=1f65da56&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f65da56"]])

export default __exports__